import axios from "axios";
const jsonConfig = require("../../Config.json");

const sharedPowerResume = async (payload) => {
    let allResponse = {};
    try {
        const sharedPoweResumeResonse = await axios.post(
            jsonConfig.apiUrl + "getSharedPoweResume",
            payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );

        allResponse = sharedPoweResumeResonse;

        return Promise.resolve(allResponse);
    }
    catch (error) {
        console.log("errrrrr", error);
        return Promise.reject(error);
    }
}

export default sharedPowerResume;